import React, { FC, Suspense } from "react";
import Layout from "layouts/Layout";
import { connect } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import LoadingPage from "../../../components/LoadingPage/LoadingPage";
import {
  authSelectAuthenticated,
  authSelectUser,
} from "../../../reduxFolder/selectors/globalSelectors";
import { isAnonymousSession } from "../../../utils/authData";

interface AuthorizedRouteProps {
  withHeader?: boolean;
  withMenu?: boolean;
  condition?: boolean;
  authenticated: boolean | null;
  redirect?: string;
}

const AuthorizedRoute: FC<AuthorizedRouteProps> = React.memo(
  ({ withHeader = true, withMenu = true, condition = false, authenticated }) => {
    // Anonymous first: a capability-gated route must not bounce a logged-out
    // visitor to "/", where LandingGate would show the landing instead.
    if (isAnonymousSession(authenticated)) return <Navigate to="/signin" />;

    if (condition) return <Navigate to="/" />;

    // Token exists but hasn't been validated yet (App's boot getProfile is in
    // flight). Mounting pages now would fire their data fetches with a possibly
    // stale token — each 401 toasts "You need to sign in or sign up..." and the
    // toast survives the redirect to /signin. Hold rendering until it settles.
    if (authenticated !== true) return <LoadingPage />;

    return (
      <Layout withHeader={withHeader} withMenu={withMenu} rightPanel>
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </Layout>
    );
  },
);

const withConnect = connect(
  createStructuredSelector({
    user: authSelectUser,
    authenticated: authSelectAuthenticated,
  }),
);

export default withConnect(AuthorizedRoute);
